type ScrollToState = 'nearest' | 'center' | 'end' | 'start'

interface ScrollIntoViewParams {
  block: ScrollToState
  inline: ScrollToState
  behavior: 'smooth' | 'instant' | 'auto'
}

export const scrollIntoView = (
  selector: string,
  params?: Partial<ScrollIntoViewParams>,
) => {
  const el = document.querySelector(selector)
  if (el) {
    el.scrollIntoView({
      block: 'nearest',
      inline: 'center',
      behavior: 'smooth',
      ...params,
    })
  }
  // If element not found, silently skip
}
